import APIService from 'services/APIService'

const api = APIService()

export const fetchProgramme = bpId =>
  api.get(`/building-passport/${bpId}/compliance/programme`)

export const fetchComplianceSetupOverview = () =>
  api.get('/me/compliance-setup')

export const logComplianceSetupAction = ({ buildingPassportId, obligationName, action }) =>
  api.post('/me/compliance-setup/log-action', { buildingPassportId, obligationName, action })

export const setComplianceTracking = (bpId, enabled) =>
  api.post(`/building-passport/${bpId}/compliance/tracking`, { enabled })

export const updateProgrammeObligation = (bpId, obligationId, payload) =>
  api.patch(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}`, payload)

export const deleteProgrammeObligation = (bpId, obligationId) =>
  api.delete(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}`)

export const getObligationScopeImpact = (bpId, obligationId) =>
  api.get(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/scope-impact`)

export const fetchAvailableObligations = bpId =>
  api.get(`/building-passport/${bpId}/compliance/programme/available-obligations`)

export const addProgrammeObligation = (bpId, payload) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations`, payload)

export const getObligationCandidateFiles = (bpId, obligationId) =>
  api.get(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/candidate-files`)

export const linkObligationEvidence = (bpId, obligationId, payload) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/link-evidence`, payload)

export const suggestObligationMappings = bpId =>
  api.get(`/building-passport/${bpId}/compliance/programme/match-existing-files`)

export const applyObligationMappings = (bpId, mappings) =>
  api.post(`/building-passport/${bpId}/compliance/programme/map-existing-files`, { mappings })

export const logObligationCompletion = (bpId, obligationId, payload) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/log-completion`, payload)

export const recordPastCompliance = (bpId, obligationId, payload) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/record-past-compliance`, payload)

export const fetchObligationHistory = (bpId, obligationId) =>
  api.get(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/history`)

export const markProgrammeReviewed = bpId =>
  api.post(`/building-passport/${bpId}/compliance/programme/mark-reviewed`)

export const flagObligation = ({ librarySlug, ...payload }) =>
  api.post(`/me/dashboard/obligations/${librarySlug}/flags`, payload)

export const createObligation = payload =>
  api.post('/me/dashboard/obligations', payload)

export const fetchTaskDomains = () =>
  api.get('/task-domains')

export const createTaskDomain = payload =>
  api.post('/task-domains', payload)

export const updateTaskDomain = (id, payload) =>
  api.patch('/task-domains/' + id, payload)

export const deleteTaskDomain = id =>
  api.delete('/task-domains/' + id)
